<template>
  <div class="box4-container">
    <div class="content">
      <div class="gas_list">
        <ul>
          <li v-for="(item,index) in gasData.slice(0,8)" :key="index">
            <h3 v-if="index>4" class="yellow">{{item.value}}</h3>
            <h3 v-else>{{item.value}}</h3>
            <span>{{item.name}}
              <em v-if="item.unit">({{item.unit}})</em>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>   
</template>

<script>
export default {
  name: 'Box4', 
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return [

        ]
      }
    },
  },
  data() {
    return {
      gasData:[
        {
          name: this.$t("home.box4.text1"),
          unit: '°C',
          value: 0
        },
        {
          name: this.$t("home.box4.text2"),
          unit: 'RH%',
          value: 0
        },
        {
          name: 'PM2.5',
          unit: 'μg/m3',
          value: 0
        },
        {
          name: 'PM10',
          unit: 'μg/m3',
          value: 0
        },
        {
          name: this.$t("home.box4.text3"),
          unit: 'lux',
          value: 0
        },
        {
          name: this.$t("home.box4.text4"),
          unit: 'm/s',
          value: 0
        },
        {
          name: this.$t("home.box4.text5"),
          unit: '',
          value: ''
        },
        {
          name: this.$t("home.box4.text6"),
          unit: 'db',
          value: 0
        }
      ]
    }
  },
  watch: {
    itemData: function(newVal){
      if(newVal.length>0){
        this.gasData = newVal;
      }
    }
  }
}
</script>
<style lang='less'>
.box4-container {
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 10px 0;
  }
}

.gas_list {
  width: 100%;
  height:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ul{
    width: 100%;
    height:100%;
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
	  flex-wrap: wrap; 
    li{
      width: 25%; 
      position: relative;
      margin: 0;
      // margin-top:10px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      h3{
        margin: 0;
        padding: 0;
        width:65px;
        height:65px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(../../assets/home_images/box4/box4_blue.png);
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: normal;
        color: #fff;
        font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
      }
      h3.yellow{
        background-image: url(../../assets/home_images/box4/box4_yellow.png);
      }
      h3.red{
        background-image: url(../../assets/home_images/box4/box4_red.png);
      }
      span{
        display: block;
        font-size:12px;
        margin:0;
        padding:0;
        margin-top:3px;
        color:#fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        em{
          font-style: normal;
        }
      }
    }
    li:last-child{
      h3{
        font-size: 14px;
        font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif;;
      }
    }
  }
}
</style>
